import React, { useState } from 'react';
import {
    FaUser,
    FaIdCard,
    FaPhone,
    FaEnvelope,
    FaHome,
    FaMapMarkedAlt,
    FaUpload,
    FaFilePdf,
    FaCheckCircle,
    FaArrowLeft,
    FaArrowRight,
    FaInfoCircle,
    FaBuilding,
    FaCalendarCheck,
    FaClipboardList,
    FaPrint
} from 'react-icons/fa';

const AjukanPermohonanIPT = () => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        // Data Pemohon
        namaLengkap: '',
        nik: '',
        noTelp: '',
        email: '',
        alamat: '',
        pekerjaan: '',

        // Data Tanah
        lokasiTanah: '',
        luasTanah: '',
        statusTanah: 'milik_pemkot',
        zona: '',
        peruntukan: '',
        jangkaWaktu: '1',
        deskripsiPenggunaan: '',

        // Dokumen
        ktp: null,
        npwp: null,
        proposal: null,
        sitePlan: null,
        suratPernyataan: null,
        dokumenPendukung: null
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [nomorRegistrasi, setNomorRegistrasi] = useState('');

    const zonaOptions = [
        { value: 'pusat', label: 'Pusat Kota' },
        { value: 'menengah', label: 'Zona Menengah' },
        { value: 'pinggiran', label: 'Zona Pinggiran' }
    ];

    const peruntukanOptions = [
        { value: 'komersial', label: 'Komersial (Ruko, Toko, Restoran)' },
        { value: 'industri', label: 'Industri (Pabrik, Gudang)' },
        { value: 'sosial', label: 'Sosial (Sekolah, Rumah Ibadah)' },
        { value: 'pertanian', label: 'Pertanian (Sawah, Ladang)' }
    ];

    const validateStep = (stepNumber) => {
        const newErrors = {};

        if (stepNumber === 1) {
            if (!formData.namaLengkap) newErrors.namaLengkap = 'Nama lengkap wajib diisi';
            if (!formData.nik) newErrors.nik = 'NIK wajib diisi';
            else if (formData.nik.length !== 16) newErrors.nik = 'NIK harus 16 digit';
            if (!formData.noTelp) newErrors.noTelp = 'Nomor telepon wajib diisi';
            if (!formData.alamat) newErrors.alamat = 'Alamat wajib diisi';
            if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
                newErrors.email = 'Format email tidak valid';
            }
        }

        if (stepNumber === 2) {
            if (!formData.lokasiTanah) newErrors.lokasiTanah = 'Lokasi tanah wajib diisi';
            if (!formData.luasTanah) newErrors.luasTanah = 'Luas tanah wajib diisi';
            else if (formData.luasTanah <= 0) newErrors.luasTanah = 'Luas tanah tidak valid';
            if (!formData.zona) newErrors.zona = 'Zona lokasi wajib dipilih';
            if (!formData.peruntukan) newErrors.peruntukan = 'Peruntukan wajib dipilih';
            if (!formData.deskripsiPenggunaan) newErrors.deskripsiPenggunaan = 'Deskripsi penggunaan wajib diisi';
        }

        if (stepNumber === 3) {
            if (!formData.ktp) newErrors.ktp = 'Foto/Scan KTP wajib diupload';
            if (!formData.proposal) newErrors.proposal = 'Proposal penggunaan wajib diupload';
            if (!formData.suratPernyataan) newErrors.suratPernyataan = 'Surat pernyataan wajib diupload';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        // Clear error for this field
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleFileUpload = (e) => {
        const { name, files } = e.target;
        if (files[0]) {
            setFormData(prev => ({ ...prev, [name]: files[0] }));
            // Clear error for this field
            if (errors[name]) {
                setErrors(prev => ({ ...prev, [name]: '' }));
            }
        }
    };

    const nextStep = () => {
        if (validateStep(step)) {
            setStep(prev => prev + 1);
            window.scrollTo(0, 0);
        }
    };

    const prevStep = () => {
        setStep(prev => prev - 1);
        window.scrollTo(0, 0);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateStep(3)) return;

        setIsSubmitting(true);

        // Simulasi pengiriman data
        setTimeout(() => {
            const noReg = 'IPT-' + new Date().getFullYear() + '-' + Math.random().toString(36).substr(2, 8).toUpperCase();
            setNomorRegistrasi(noReg);
            setShowSuccess(true);
            setIsSubmitting(false);
            window.scrollTo(0, 0);
        }, 2000);
    };

    const renderStepIndicator = () => (
        <div className="flex items-center justify-center mb-8">
            {[1, 2, 3].map((item) => (
                <React.Fragment key={item}>
                    <div className="flex items-center">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold ${step >= item
                                ? 'bg-[#0D9488] text-white'
                                : 'bg-gray-300 text-gray-600'
                            }`}>
                            {step > item ? <FaCheckCircle /> : item}
                        </div>
                        <span className={`ml-2 text-sm font-medium ${step >= item ? 'text-[#0D9488]' : 'text-gray-500'
                            }`}>
                            {item === 1 ? 'Data Diri' : item === 2 ? 'Data Tanah' : 'Dokumen'}
                        </span>
                    </div>
                    {item < 3 && (
                        <div className={`w-16 h-1 mx-2 ${step > item ? 'bg-[#0D9488]' : 'bg-gray-300'
                            }`} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );

    // Tampilan Sukses
    if (showSuccess) {
        return (
            <div className="container mx-auto px-4 py-12">
                <div className="max-w-2xl mx-auto">
                    <div className="card-glass text-center">
                        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <FaCheckCircle className="text-5xl text-green-500" />
                        </div>
                        <h2 className="text-2xl font-bold text-[#1E3A8A] mb-4">
                            Permohonan Berhasil Diajukan!
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Terima kasih telah mengajukan permohonan Izin Pemakaian Tanah.
                            Berikut adalah nomor registrasi Anda:
                        </p>

                        <div className="bg-[#1E3A8A] text-white p-6 rounded-lg mb-6">
                            <p className="text-sm opacity-80 mb-2">Nomor Registrasi</p>
                            <p className="text-3xl font-bold">{nomorRegistrasi}</p>
                        </div>

                        <div className="text-left bg-gray-50 p-6 rounded-lg mb-6">
                            <h3 className="font-bold text-[#1E3A8A] mb-3 flex items-center">
                                <FaClipboardList className="mr-2" />
                                Informasi Selanjutnya:
                            </h3>
                            <ul className="space-y-2 text-sm text-gray-600">
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    Simpan nomor registrasi untuk mengecek status permohonan
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    Petugas akan memverifikasi dokumen dalam 1-3 hari kerja
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    Tim survey akan menghubungi Anda untuk jadwal peninjauan lokasi
                                </li>
                                <li className="flex items-start">
                                    <FaCheckCircle className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                                    Status permohonan dapat dicek secara online dengan nomor registrasi
                                </li>
                            </ul>
                        </div>

                        <div className="flex flex-col md:flex-row gap-4">
                            <button
                                onClick={() => window.print()}
                                className="flex-1 bg-[#0F172A] text-white px-6 py-3 rounded-lg font-semibold hover:bg-opacity-90 transition-colors flex items-center justify-center"
                            >
                                <FaPrint className="mr-2" />
                                Cetak Bukti
                            </button>
                            <button
                                onClick={() => {
                                    setShowSuccess(false);
                                    setStep(1);
                                    setFormData({
                                        namaLengkap: '', nik: '', noTelp: '', email: '', alamat: '', pekerjaan: '',
                                        lokasiTanah: '', luasTanah: '', statusTanah: 'milik_pemkot', zona: '', peruntukan: '',
                                        jangkaWaktu: '1', deskripsiPenggunaan: '',
                                        ktp: null, npwp: null, proposal: null, sitePlan: null, suratPernyataan: null, dokumenPendukung: null
                                    });
                                }}
                                className="flex-1 btn-primary flex items-center justify-center"
                            >
                                <FaFilePdf className="mr-2" />
                                Ajukan Permohonan Baru
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Header */}
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-[#1E3A8A] mb-2">
                    Formulir Pengajuan Izin Pemakaian Tanah (IPT)
                </h1>
                <p className="text-gray-600">
                    Lengkapi formulir berikut untuk mengajukan permohonan Izin Pemakaian Tanah
                </p>
            </div>

            {/* Step Indicator */}
            {renderStepIndicator()}

            <div className="max-w-4xl mx-auto">
                <div className="card-glass">
                    <form onSubmit={handleSubmit}>
                        {/* Step 1: Data Pemohon */}
                        {step === 1 && (
                            <div className="space-y-6">
                                <div className="flex items-center mb-4">
                                    <FaUser className="text-2xl text-[#0D9488] mr-3" />
                                    <h2 className="text-xl font-bold text-[#1E3A8A]">Data Pemohon</h2>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Nama Lengkap <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="namaLengkap"
                                            value={formData.namaLengkap}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.namaLengkap ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                            placeholder="Masukkan nama lengkap sesuai KTP"
                                        />
                                        {errors.namaLengkap && (
                                            <p className="text-red-500 text-xs mt-1">{errors.namaLengkap}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            NIK <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="nik"
                                            value={formData.nik}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.nik ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                            placeholder="Masukkan 16 digit NIK"
                                            maxLength="16"
                                        />
                                        {errors.nik && (
                                            <p className="text-red-500 text-xs mt-1">{errors.nik}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Nomor Telepon <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="tel"
                                            name="noTelp"
                                            value={formData.noTelp}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.noTelp ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                            placeholder="Contoh: 08123456789"
                                        />
                                        {errors.noTelp && (
                                            <p className="text-red-500 text-xs mt-1">{errors.noTelp}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.email ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                            placeholder="contoh@email.com"
                                        />
                                        {errors.email && (
                                            <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                                        )}
                                    </div>

                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Alamat Lengkap <span className="text-red-500">*</span>
                                        </label>
                                        <textarea
                                            name="alamat"
                                            value={formData.alamat}
                                            onChange={handleInputChange}
                                            rows="3"
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.alamat ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                            placeholder="Masukkan alamat lengkap sesuai KTP"
                                        />
                                        {errors.alamat && (
                                            <p className="text-red-500 text-xs mt-1">{errors.alamat}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Pekerjaan
                                        </label>
                                        <input
                                            type="text"
                                            name="pekerjaan"
                                            value={formData.pekerjaan}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                            placeholder="Masukkan pekerjaan"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Step 2: Data Tanah */}
                        {step === 2 && (
                            <div className="space-y-6">
                                <div className="flex items-center mb-4">
                                    <FaMapMarkedAlt className="text-2xl text-[#0D9488] mr-3" />
                                    <h2 className="text-xl font-bold text-[#1E3A8A]">Data Tanah yang Dimohon</h2>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Lokasi Tanah <span className="text-red-500">*</span>
                                        </label>
                                        <textarea
                                            name="lokasiTanah"
                                            value={formData.lokasiTanah}
                                            onChange={handleInputChange}
                                            rows="2"
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.lokasiTanah ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                            placeholder="Masukkan alamat lengkap lokasi tanah (Jl., Kelurahan, Kecamatan)"
                                        />
                                        {errors.lokasiTanah && (
                                            <p className="text-red-500 text-xs mt-1">{errors.lokasiTanah}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Luas Tanah (m²) <span className="text-red-500">*</span>
                                        </label>
                                        <div className="relative">
                                            <input
                                                type="number"
                                                name="luasTanah"
                                                value={formData.luasTanah}
                                                onChange={handleInputChange}
                                                className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.luasTanah ? 'border-red-500' : 'border-gray-300'
                                                    }`}
                                                placeholder="Masukkan luas tanah"
                                            />
                                            <span className="absolute right-3 top-2 text-gray-400">m²</span>
                                        </div>
                                        {errors.luasTanah && (
                                            <p className="text-red-500 text-xs mt-1">{errors.luasTanah}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Status Tanah
                                        </label>
                                        <select
                                            name="statusTanah"
                                            value={formData.statusTanah}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            <option value="milik_pemkot">Milik Pemkot Magelang</option>
                                            <option value="pengelolaan_bpkad">Dalam Pengelolaan BPKAD</option>
                                            <option value="fasum">Fasilitas Umum</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Zona Lokasi <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="zona"
                                            value={formData.zona}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.zona ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        >
                                            <option value="">Pilih Zona</option>
                                            {zonaOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                        {errors.zona && (
                                            <p className="text-red-500 text-xs mt-1">{errors.zona}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Peruntukan <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            name="peruntukan"
                                            value={formData.peruntukan}
                                            onChange={handleInputChange}
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.peruntukan ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                        >
                                            <option value="">Pilih Peruntukan</option>
                                            {peruntukanOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                        {errors.peruntukan && (
                                            <p className="text-red-500 text-xs mt-1">{errors.peruntukan}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Jangka Waktu
                                        </label>
                                        <select
                                            name="jangkaWaktu"
                                            value={formData.jangkaWaktu}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            <option value="1">1 Tahun</option>
                                            <option value="2">2 Tahun</option>
                                            <option value="3">3 Tahun</option>
                                            <option value="5">5 Tahun</option>
                                        </select>
                                    </div>

                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Deskripsi Penggunaan Tanah <span className="text-red-500">*</span>
                                        </label>
                                        <textarea
                                            name="deskripsiPenggunaan"
                                            value={formData.deskripsiPenggunaan}
                                            onChange={handleInputChange}
                                            rows="4"
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent ${errors.deskripsiPenggunaan ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                            placeholder="Jelaskan rencana penggunaan tanah secara detail"
                                        />
                                        {errors.deskripsiPenggunaan && (
                                            <p className="text-red-500 text-xs mt-1">{errors.deskripsiPenggunaan}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Step 3: Upload Dokumen */}
                        {step === 3 && (
                            <div className="space-y-6">
                                <div className="flex items-center mb-4">
                                    <FaUpload className="text-2xl text-[#0D9488] mr-3" />
                                    <h2 className="text-xl font-bold text-[#1E3A8A]">Upload Dokumen Pendukung</h2>
                                </div>

                                <div className="bg-yellow-50 p-4 rounded-lg mb-4 flex items-start">
                                    <FaInfoCircle className="text-yellow-600 mt-1 mr-3 flex-shrink-0" />
                                    <p className="text-sm text-yellow-800">
                                        Format file yang diterima: PDF, JPG, PNG. Ukuran maksimal 5MB per file.
                                        File wajib diupload untuk dokumen bertanda <span className="text-red-500">*</span>
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    {/* KTP */}
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Foto/Scan KTP <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="file"
                                            name="ktp"
                                            onChange={handleFileUpload}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            className="w-full"
                                        />
                                        {formData.ktp && (
                                            <p className="text-sm text-green-600 mt-1">
                                                ✓ {formData.ktp.name}
                                            </p>
                                        )}
                                        {errors.ktp && (
                                            <p className="text-red-500 text-xs mt-1">{errors.ktp}</p>
                                        )}
                                    </div>

                                    {/* NPWP */}
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Foto/Scan NPWP (Opsional)
                                        </label>
                                        <input
                                            type="file"
                                            name="npwp"
                                            onChange={handleFileUpload}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            className="w-full"
                                        />
                                        {formData.npwp && (
                                            <p className="text-sm text-green-600 mt-1">
                                                ✓ {formData.npwp.name}
                                            </p>
                                        )}
                                    </div>

                                    {/* Proposal */}
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Proposal Penggunaan Tanah <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="file"
                                            name="proposal"
                                            onChange={handleFileUpload}
                                            accept=".pdf"
                                            className="w-full"
                                        />
                                        {formData.proposal && (
                                            <p className="text-sm text-green-600 mt-1">
                                                ✓ {formData.proposal.name}
                                            </p>
                                        )}
                                        {errors.proposal && (
                                            <p className="text-red-500 text-xs mt-1">{errors.proposal}</p>
                                        )}
                                    </div>

                                    {/* Site Plan */}
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Gambar Site Plan/Lokasi (Opsional)
                                        </label>
                                        <input
                                            type="file"
                                            name="sitePlan"
                                            onChange={handleFileUpload}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            className="w-full"
                                        />
                                        {formData.sitePlan && (
                                            <p className="text-sm text-green-600 mt-1">
                                                ✓ {formData.sitePlan.name}
                                            </p>
                                        )}
                                    </div>

                                    {/* Surat Pernyataan */}
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Surat Pernyataan Bermaterai <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="file"
                                            name="suratPernyataan"
                                            onChange={handleFileUpload}
                                            accept=".pdf"
                                            className="w-full"
                                        />
                                        {formData.suratPernyataan && (
                                            <p className="text-sm text-green-600 mt-1">
                                                ✓ {formData.suratPernyataan.name}
                                            </p>
                                        )}
                                        {errors.suratPernyataan && (
                                            <p className="text-red-500 text-xs mt-1">{errors.suratPernyataan}</p>
                                        )}
                                    </div>

                                    {/* Dokumen Pendukung */}
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Dokumen Pendukung Lainnya (Opsional)
                                        </label>
                                        <input
                                            type="file"
                                            name="dokumenPendukung"
                                            onChange={handleFileUpload}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            className="w-full"
                                            multiple
                                        />
                                        {formData.dokumenPendukung && (
                                            <p className="text-sm text-green-600 mt-1">
                                                ✓ {formData.dokumenPendukung.name}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Navigation Buttons */}
                        <div className="flex justify-between mt-8 pt-6 border-t border-gray-200">
                            {step > 1 ? (
                                <button
                                    type="button"
                                    onClick={prevStep}
                                    className="flex items-center px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                >
                                    <FaArrowLeft className="mr-2" />
                                    Sebelumnya
                                </button>
                            ) : (
                                <div></div>
                            )}

                            {step < 3 ? (
                                <button
                                    type="button"
                                    onClick={nextStep}
                                    className="flex items-center btn-primary"
                                >
                                    Selanjutnya
                                    <FaArrowRight className="ml-2" />
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`flex items-center btn-primary ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                        }`}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                                            Mengirim...
                                        </>
                                    ) : (
                                        <>
                                            <FaCheckCircle className="mr-2" />
                                            Kirim Permohonan
                                        </>
                                    )}
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AjukanPermohonanIPT;